/*
 * @Author: vivien
 * @Date: 2021-01-27 09:21:58
 * @Last Modified by: vivien
 * @LastEditTime: 2021-12-30 14:56:43
 */
import _comMeds from '@src/assets/js/common.js';
import _memberRgihts from '@src/assets/js/totalUse/memberRights.js';
import _allPayBox from '@src/assets/js/totalUse/allPayBox.js';
import _account from '@src/assets/js/server/account-server.js';
import { xieyiBox } from '@src/assets/js/totalUse/userXieyi.js';
import './index.scss';

var page = {
    data: {
        isMember: false, // 是否是会员
    },
    init: function() {
        this.bindEvent();
        this.onLoad();
        _comMeds.tabsCheck(7)
    },
    bindEvent: function(){
        let _this = this;
        $(window).on('beforeunload', function () {  
            _comMeds.checkLeave(7)
        })
       $('.rights-detail-popBox .close-icon').remove();

       // 点击立即购买vip按钮
        $('body').on('click', '.fixed-bottom .btn', _comMeds.throttle(function(e){
            _comMeds.countLink(142)
            if(_comMeds.isLogin()){
                    if(_this.data.isMember){
                        return false;
                    } else {
                        let payObj = {
                            payTab: 1,
                            payIndex: 0,
                        }
                        _allPayBox.payBox(payObj)
                    }
            } else {
                _comMeds.doLogin();
            }
        }))
    },
    onLoad: function() {
        if(_comMeds.isLogin()){
            this.getUserInfo();
            this.getIsAgree();
        }
        this.getTime()
    },
    getUserInfo() {
        let _this = this;
        _comMeds.getBaseUserInfoReq({},function(res){
            if(res.memberStatus.memberType.memberType == 'month'){
                $('.fixed-bottom .btn').text('您已是尊贵的VIP会员');
                _this.data.isMember = true;
            } else {
                $('.fixed-bottom .btn').text('立即充值VIP');
                _this.data.isMember = false;
            }
        })
    },
     // 判断用户是否同意用户协议
     getIsAgree() {
		_account.getIsAgree({}, function(res){
			if(res == 0){
				xieyiBox().then(function(){
					$('.common-xieyi-bg').remove();
				});
			}
		})
	},

    isDuringDate: function (beginDateStr, endDateStr) {
        var curDate = new Date(),
            beginDate = new Date(beginDateStr),
            endDate = new Date(endDateStr);
        if (curDate >= beginDate && curDate <= endDate) {
            return true;
        }
        return false;
    },

    getTime() {
        let a = this.isDuringDate('2021/12/30 00:00:01', '2021/12/31 23:59:59') 
        let b = this.isDuringDate('2022/01/01 00:00:01', '2022/01/31 23:59:59') 
        let c = this.isDuringDate('2022/02/01 00:00:01', '2022/02/28 23:59:59') 

        if(a || b || c) {
            $(".vip_upgrade_top").show()
        }else {
            $(".vip_upgrade_top").hide()
        }
    },
}

$(function(){
    page.init();
    _memberRgihts.init();
    _allPayBox.init();
})